import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-form-customer-logo-upload",
  template: `<label for="upload-logo">
    <div id="upload-area" *ngIf="!logoBase64">
      <div>{{ "SELECT_FILE" | translate }}</div>
    </div>
    <img *ngIf="logoBase64" [src]="logoBase64" [alt]="'LOGO' | translate" />
    <input type="file" lang="it" id="upload-logo" accept="image/*" #logoInput (change)="handlerChangeFileInput(logoInput)" />
  </label>`,
  styleUrls: ["./form-customer-logo-upload.component.scss"],
})
export class FormCustomerLogoUploadComponent implements OnInit {
  @Input() customer: any;
  @Output() change: EventEmitter<any> = new EventEmitter();

  public logoBase64: any;

  constructor(
    private _utilService: UtilsService,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.logoBase64 = this.customer.logo;
  }

  handlerChangeFileInput(target: any) {
    if (!!target.value) {
      this._utilService.convertFileToBase64({ target }, (e: any) => {
        this.logoBase64 = this.domSanitizer.bypassSecurityTrustUrl(e.target.result);
        this.change.emit(e.target.result);
      });
    } else {
      this.logoBase64 = "";
      this.change.emit("");
    }
  }
}
